import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	setupReleaseAutomation: {
		id: 'project-directories.versions.release-version-modal.content.release-automation-banner.setup-release-automation',
		defaultMessage: 'Set up release automation',
		description:
			'Call to action text encouraging a release manager to set up an automation workflow for when they release a version. This link will open up the automation settings page in a new tab.',
	},
	dismiss: {
		id: 'project-directories.versions.release-version-modal.content.release-automation-banner.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Label for icon button which is for dismissing the banner',
	},
});
